import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'
import { UserFile } from 'service/user'

export const useGetSynthesisRequestStatus = (
  id: number | null,
  time?: number
) => {
  return useQuery({
    queryKey: ['synthesis-request-status', id],
    queryFn: () => aiStudioService.getSynthesisRequestStatus(id!), // API 함수
    enabled: !!id,
    refetchOnMount: true, // 마운트 시 즉시 실행
    refetchInterval: (query) => {
      // query.state.data가 실제 응답 데이터
      const data = query.state.data

      if (data?.status === 'completed' || data?.status === 'failed') {
        return false // 폴링 중단
      }
      return time ? time : 3000 // 3초마다 폴링 계속
    },
    refetchIntervalInBackground: false,
    staleTime: 0, // 항상 fresh하지 않도록 설정하여 즉시 refetch
  })
}
